import React from 'react'
import styles from './styles.module.css'


export default function HaventPermission () {
  return (
    <div className={styles.wrap}>
      Недостаточно прав
    </div>
  )
}
